import theme from '../../../theme';

export const contractItemSx = {
    menuBtnText: {
        width: '100%',
        textAlign: 'start',
        fontSize: theme.spacing(14 / 8),
        fontWeight: 400,
        color: theme.palette.neutral[400],
    },
    iconBtn: {
        width: theme.spacing(20 / 8),
        height: theme.spacing(20 / 8),
        backgroundColor: 'transparent',
    },
    popover: {
        '& .MuiPaper-root': {
            maxWidth: theme.spacing(200 / 8),
            width: '100%',
            p: 1,
        },
    },
    dataText: {
        fontSize: theme.spacing(12 / 8),
        fontWeight: 400,
        textAlign: 'end',
    },
    idText: {
        color: theme.palette.primary.main,
    },
    withIcon: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 0.5,
    },
    // The card's title is also the way into the contract. It reads as the title the canvas drew
    // rather than as a link, so the colour and the underline come off and the route stays.
    titleLink: {
        color: 'inherit',
        textDecoration: 'none',
    },
};
